import { PayloadAction, createSlice } from "@reduxjs/toolkit";
//import { RootState } from "../../store";

interface SearchState {
  openModalSearch: boolean;
  searchTerm: string;
  selectedSegmentations: number[];
  selectedCategories: number[];
  selectedCountries: number[];
  selectedItems: number[];
  selectedMaterials: number[];
  typeQuery: string;
  refreshing: boolean;
  loadingMore: boolean;
  hasMore: boolean;
}

const initialState: SearchState = {
  openModalSearch: false,
  searchTerm: "",
  selectedSegmentations: [],
  selectedCategories: [],
  selectedCountries: [],
  selectedItems: [],
  selectedMaterials: [],
  typeQuery: "",
  refreshing: false,
  loadingMore: false,
  hasMore: false,
};

export const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setOpenModalSearch: (state, action: PayloadAction<SearchState>) => {
      state.openModalSearch = action.payload.openModalSearch;
    },
    setSearchTerm: (state, action: PayloadAction<SearchState>) => {
      state.searchTerm = action.payload.searchTerm;
    },
    setSelectedSegmentations: (state, action: PayloadAction<SearchState>) => {
      state.selectedSegmentations = action.payload.selectedSegmentations;
    },
    setSelectedCategories: (state, action: PayloadAction<SearchState>) => {
      state.selectedCategories = action.payload.selectedCategories;
    },
    setSelectedCountries: (state, action: PayloadAction<SearchState>) => {
      state.selectedCountries = action.payload.selectedCountries;
    },
    setSelectedItems: (state, action: PayloadAction<SearchState>) => {
      state.selectedItems = action.payload.selectedItems;
    },
    setSelectedMaterials: (state, action: PayloadAction<SearchState>) => {
      state.selectedMaterials = action.payload.selectedMaterials;
    },
    setTypeQuery: (state, action: PayloadAction<SearchState>) => {
      state.typeQuery = action.payload.typeQuery;
    },
    setRefreshing: (state, action: PayloadAction<SearchState>) => {
      state.refreshing = action.payload.refreshing;
    },
    setLoadingMore: (state, action: PayloadAction<SearchState>) => {
      state.loadingMore = action.payload.loadingMore;
    },
    setHasMore: (state, action: PayloadAction<SearchState>) => {
      state.hasMore = action.payload.hasMore;
    },
  },
});

export const {
  setSearchTerm,
  setSelectedSegmentations,
  setSelectedCategories,
  setSelectedCountries,
  setSelectedItems,
  setSelectedMaterials,
  setTypeQuery,
  setRefreshing,
  setLoadingMore,
  setHasMore,
} = searchSlice.actions;
// export const selectSnackbarStatus = (state: RootState) => state.snackbar;

export default searchSlice.reducer;
